import { render, staticRenderFns } from "./MessageLink.vue?vue&type=template&id=c25c0d38&scoped=true&"
import script from "./MessageLink.vue?vue&type=script&lang=ts&"
export * from "./MessageLink.vue?vue&type=script&lang=ts&"
import style0 from "./MessageLink.vue?vue&type=style&index=0&id=c25c0d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25c0d38",
  null
  
)

export default component.exports